import Page from 'components/Page';
import React from 'react';
import {Button, ButtonGroup, Card, CardBody, Col, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import {allIsEmpty, cloneObject, deleteParam, parseDate} from '../utils/Utilities';
import {MdEdit} from 'react-icons/md';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import queryString from "query-string";
import Pagination from "../components/Pagination";
import SearchInput from "../components/SearchInput";
import ComponentGroupDetailPage from "./ComponentGroupDetailPage";
import {delegateObjectsForSelection, navigate} from "enqc-utilities/src/utils/Utilities";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import DropdownInput from "../components/form/DropdownInput";
import ActiveLabel from "../components/Widget/ActiveLabel";

const tableTypes = ['', 'bordered', 'striped', 'hover'];


class ComponentGroupPage extends BasePage{
  constructor(props) {
    super(props);
    this.state = {
      componentGroups : [],
      componentGroup:{},
      modalAddConfirm:false,
      modalDeleteConfirm:false,
      image : undefined,
      modal: false,
      ascending:true,
      sortir:'jcg.created',
      page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
      totalPage:0,
      totalElement:0,
      pageElement:0,
    }
  }

  componentDidMount() {
    super.componentDidMount();
    this.fetchAll(true)
  }

  componentWillReceiveProps(props, nextContext) {
    if(props!=this.props){
      this.setState({
        page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
      }, () => {
        this.fetchAll(true)
      })
    }
  }



  fetchAll = (progressing) => {
    let {ascending, sortir, search, page} = this.state
    this.get(Endpoint.API.COMPONENT_GROUPS, {
      params:{
        ascending:ascending,
        sortir:sortir,
        search:search,
        page: page-1
      }
    }, null, res=>{
      if(res.code === 200){
        this.setState({
          componentGroups : res.data,
          totalPage: res.totalPage,
          totalElement: res.totalElement,
          pageElement: res.pageElement,
        })
      }
    },progressing, true);
  }



  confirmSave = () =>{
    let componentGroup = this.state.componentGroup
    let image = this.state.imageBlob
    if(componentGroup.id){
      if(allIsEmpty(componentGroup.name)){
        this.showDialog(label.Warning, label.PleaseCompleteTheFields)
      }else{
        this.setState({
          modalAddConfirm:true
        })
      }
    }else{
      if(allIsEmpty(image, componentGroup.name)){
        this.showDialog(label.Warning, label.PleaseCompleteTheFields)
      }else{
        this.setState({
          modalAddConfirm:true
        })
      }
    }
  }


  save = () => {
    let componentGroup = this.state.componentGroup
    let imageBlob = this.state.imageBlob
    var formData = new FormData();

    if(!componentGroup.id && !componentGroup.active){
      componentGroup.active = false ;
    }

    formData.append("componentGroupJson", JSON.stringify(componentGroup))
    formData.append("multipartFile", imageBlob);
    this.setState({
      modalAddConfirm:false
    }, () => {
      this.post(Endpoint.API.COMPONENT_GROUP_SAVE, formData, null, res=>{
        if(res.code===200){
          this.setState({
            componentGroup:{},
            image:undefined
          }, () => {
            this.showDialog(label.Success, res.message)
            this.fetchAll(true)
          })
        }
      },  true, true)
    })
  }


  confirmDelete = () =>{
    this.setState({
      modalDeleteConfirm:true
    })
  }

  delete = () => {
    this.setState({
      modalDeleteConfirm:false
    }, () => {
      this.get(Endpoint.API.COMPONENT_GROUP_DELETE+"/"+this.state.componentGroup.id, null, null, res => {
        if(res.code===200){
          this.setState({
            componentGroup:{}
          }, () => {
            this.fetchAll(true)
          })
        }
      },true, true);
    })
  }

  closeDialog = () =>{
    this.setState({
      modalAddConfirm:false,
      modalDeleteConfirm:false
    })
  }

  refresh = (ascending, sortir) => (
      this.setState({
        ascending:ascending,
        sortir:sortir
      }, () => {
        this.fetchAll(true)
      })
  )


  render() {
    let aspect = 4/4
    let {image, componentGroups} = this.state
    if(!componentGroups){
      componentGroups = []
    }
    let {ascending, sortir} = this.state
    let orderOptions = delegateObjectsForSelection(
        {name:label.SystemType, field:'jm.systemType'},
        {name:label.Name, field:'jm.modelName'},
        {name:label.PartNumber, field:'jm.partNumber'},
        {name:label.Created, field:'jcg.created'},
        {name:label.Updated, field:'jcg.updated'}
    )
    let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})


    return (
        <Page
            title={label.ComponentGroups}
            breadcrumbs={[{ name: label.ComponentGroups, active: true }]}
            className="TablePage">
          {super.render()}
          <ConfirmDialog
              showing={this.state.modalAddConfirm}
              title={label.UpdateConfirmation}
              message={label.UpdateConfirmationMessage}
              okCallback={this.save}
              cancelCallback={this.closeDialog}/>
          <ConfirmDialog
              showing={this.state.modalDeleteConfirm}
              title={label.DeleteConfirmationTitle}
              message={label.DeleteConfirmationMessage}
              okCallback={this.delete}
              cancelCallback={this.closeDialog}/>
          <Row key={1}>
            <Col>
              <Card>
                <PrimaryCardHeader content={label.ComponentGroup}/>
                <CardBody >
                  <Row>
                    <Col md={6}>
                      <ButtonGroup className="d-flex w-100">
                        <DropdownInput
                            title={label.SortBy}
                            options={orderOptions}
                            onSelect={(item) => {
                              this.refresh(ascending, item.field, true)
                            }}
                            onReset={() => {
                              this.refresh(ascending, "created", true)
                            }}/>
                        &nbsp;&nbsp;&nbsp;
                        <DropdownInput
                            options={ascendingOptions}
                            onSelect={(item) => {
                              this.refresh(item.field, sortir, true)
                            }}
                            onReset={() => {
                              this.refresh(true, sortir, true)
                            }}/>
                      </ButtonGroup>
                    </Col>
                    <Col md={6}>
                      <SearchInput
                          placeholder={label.SearchModelByNameSystemAndPart}
                          value={this.state.search}
                          onChange={e=>{
                            this.setState({
                              search:e.target.value
                            }, () => {
                              if(this.state.search===''){
                                deleteParam(this.props, 'page')
                              }
                            })
                          }}
                          onEnter={e=>{
                            if(this.state.search!==''){
                              deleteParam(this.props, 'page')
                            }
                          }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Table responsive hover>
                        <thead>
                        <tr>
                          <th>#</th>
                          <th>{label.ModelInformation}</th>
                          <th className="text-center">{label.ComponentQuantity}</th>
                          <th>{label.Publication}</th>
                          <th>{label.Created}</th>
                          <th>{label.Updated}</th>
                          <th>{label.Edit}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                          componentGroups.map((item, index) =>(
                              <tr key={index}>
                                <th scope="row">
                                  {((this.state.page-1)* this.state.pageElement)+(index+1)}
                                </th>
                                <td>
                                  {item.model.modelCategory.name}
                                  <br/>
                                  <a href={'/modelDetail?id='+item.id}>{item.model.systemType}</a>
                                  <br/>
                                  <span className="fs-7">{label.PN}:</span><span className="font-italic text-underline h5">{item.model.partNumber}</span>
                                </td>
                                <td className="text-center justify-content-center align-content-center align-items-center fs-6">{item.componentSize}</td>
                                <td className="justify-content-center align-content-center align-items-center">
                                  <ActiveLabel
                                      active={item.model.published}
                                      trueLabel={label.Published}
                                      falseLabel={label.Unpublished}
                                      singleLabel={item.model.situationInfo}/>
                                </td>
                                <td className="justify-content-center align-content-center align-items-center">{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                <td className="justify-content-center align-content-center align-items-center">{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                <td className="justify-content-center align-content-center align-items-center">
                                  <Button color="primary" onClick={e=> {
                                    let componentGroup = cloneObject(item)
                                    navigate(this.props, ComponentGroupDetailPage.ENDPOINT+"?id="+item.id)

                                    image = componentGroup.icon?componentGroup.iconUrl:undefined
                                    this.setState({
                                      componentGroup: componentGroup,
                                      image: image
                                    })
                                  }}>
                                    <MdEdit/>
                                  </Button>
                                </td>
                              </tr>
                          ))
                        }
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </CardBody>
                <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
              </Card>
            </Col>
          </Row>

        </Page>
    );
  }
}

export default Object.assign(ComponentGroupPage, {ENDPOINT : "/componentGroups"})
